import { AxiosInstance } from 'axios';
import {IBooking} from "../../app.types";
import NetworkRequestsService from 'external-services/network-requests-service/index';

const NS = 'ApiSearchService';



export interface IBookingSearchResult {
  bookings: Array<IBooking>;
  bookmark: string;
}

const api: AxiosInstance = NetworkRequestsService.getGlobalAPI();

/**Performs booking searches using the nowbookit api */
class ApiSearchService {

  private APIBASE: string;
  private venueId: number;

  setup(apiBase: string, venueId: number): void {
    this.APIBASE = apiBase;
    this.venueId = venueId;
  }

  /**
   * Performs a substring search using the nowbookit api through all bookings
   * @param query The substring to look for
   * @param limit Maximum number of rows to return
   * @returns Array of bookings
   */
  searchAllBookings(query: string, limit: number, bookmark: string): Promise<IBookingSearchResult> {
    //${baseAPI}/search/venues/345/bookings?query=Mat&limit=100

    // Keeping a space between words to allow full name and company with multiwords search
    // no need to remove spaces for phone number search, it will be removed by the API
    const data = {
      query: query.replace(/[\-\+\(\)]/g, '').replace(/\s+/g, ' ').trim(),
      limit: limit,
      bookmark: bookmark
    };

    return api.get(this.getsearchAllBookingsUrl(), {
      params: data
    }).then((response: { data: IBookingSearchResult; }) => {
      return response.data;
    })
  }

  getsearchAllBookingsUrl(): string {
    return `${this.APIBASE}/search/venues/${this.venueId}/bookings`;
  }
}

// creates a singleton instance to export
const instance = new ApiSearchService();
export { instance as ApiSearchService };
